<template>
    <div id="WarehouseCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="warehouseHeader" v-if="$route.params.id > 0">Update Warehouse</span>
                    <span class="page-title" id="warehouseHeader" v-else>Create Warehouse</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackWarehouseList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content warehouse-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WarehouseForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{ codeerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{ nameerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="type">Warehouse Type:</label>
                                        <input type="text" class="form-control" v-model="type" id="type" placeholder="Enter Warehouse Type" name="type">
                                        <div class="field-error">{{ typeerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{ locationerrors }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="distribution_point">Distribution Point:</label>
                                        <input type="text" class="form-control" v-model="distribution_point" id="distribution_point" placeholder="Enter Distribution Point" name="distribution_point">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group mt-4">
                                        <div class="custom-checkbox">
                                            <label for="is_default" class="checkbox-custom">Warehouse Default
                                            <input type="checkbox" v-model="is_default" id="is_default_warehouse" name="is_default" v-on:click="isDefault($event)">
                                            <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col form-group mt-4">
                                      <div class="custom-checkbox">
                                        <label for="is_fuel_warehouse" class="checkbox-custom">Fuel Warehouse
                                          <input type="checkbox" v-model="is_fuel_warehouse" id="is_fuel_warehouse" name="is_fuel_warehouse" v-on:click="isFuelWarehouse($event)">
                                          <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="submit" id="createWarehouseBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateWarehouse" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createWarehouseBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateWarehouse" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueWarehouseBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateWarehouse(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelWarehouseBtn" class="btn btn-tertiary" v-on:click.prevent="BackWarehouseList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>

                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';


export default {
  name: "WarehouseCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Warehouse | " +process.env.COPYRIGHT_NAME : "Create Warehouse | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    location_id: null,
    locationArr: [],
    locationerrors: "",
    name: "",
    nameerrors: "",
    code: "",
    codeerrors: "",
    description: "",
    type: "",
    typeerrors: "",
    distribution_point: "",
    loading:false,
    is_default:false,
    is_fuel_warehouse:false,
    def_warehouse_code:"",
    def_warehouse_found:"no"
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_warehouse') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadWarehouseSearchData();
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadWarehouse();
            }
        }, 100);
  },
  methods: {

    BackWarehouseList() {
      var self = this;
      self.$router.push("/warehouse/list");
    },

    loadWarehouseSearchData() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/warehouse/search",
           type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: 'json',
            success: function (data) {

                if (data.status == "success") {

                    self.locationArr = data.Location;
                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                self.generateStatusCodeMessage(jqXHR,true,'warehouse-search')
            }
        });
    },

    CreateWarehouse(flag) {
        var self = this;
        var error = false;

        self.code = self.code.trim();

        self.nameerrors = "";
        self.codeerrors = "";
        self.locationerrors = "";
        self.typeerrors = "";

        if (!self.name || self.name == null || self.name == "") {
            self.nameerrors = "Name Required.";
            error = true;
        }

        if (!self.code || self.code == null || self.code == "") {
            self.codeerrors = "Code Required.";
            error = true;
        }

        if (self.location_id == null || !self.location_id.value) {
            self.locationerrors = "Location Required.";
            error = true;
        }

        if (!self.type || self.type == null || self.type == "") {
            self.typeerrors = "Warehouse Type Required.";
            error = true;
        }

        if (!error) {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createWarehouseBtn").val("Updating ...");
                $("#createWarehouseBtn").prop("disabled", true);
                $("#cancelWarehouseBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueWarehouseBtn").val("Saving ...");
                    $("#createWarehouseBtn").prop("disabled", true);
                    $("#createAndContinueWarehouseBtn").prop("disabled", true);
                    $("#cancelWarehouseBtn").prop("disabled",true);

                }else{

                    $("#createWarehouseBtn").val("Saving ...");
                    $("#createWarehouseBtn").prop("disabled", true);
                    $("#createAndContinueWarehouseBtn").prop("disabled", true);
                    $("#cancelWarehouseBtn").prop("disabled",true);
                }
            }

            var fields = $("#WarehouseForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "location_id", value: self.location_id.value});
            if(self.is_default == true){
                fields.push({ name: "is_default", value:1});
            }else{
                fields.push({ name: "is_default", value:0});
            }
            if(self.is_fuel_warehouse == true){
                fields.push({ name: "is_fuel_warehouse", value:1});
            }else{
                fields.push({ name: "is_fuel_warehouse", value:0});
            }
            fields.push({ name: "code", value:self.code.trim() });

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/warehouse/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createWarehouseBtn").val("Update");
                        $("#createWarehouseBtn").prop("disabled", false);
                        $("#cancelWarehouseBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueWarehouseBtn").val("Save and Continue");
                            $("#createWarehouseBtn").prop("disabled", false);
                            $("#createAndContinueWarehouseBtn").prop("disabled", false);
                            $("#cancelWarehouseBtn").prop("disabled",false);

                        }else{

                            $("#createWarehouseBtn").val("Save");
                            $("#createWarehouseBtn").prop("disabled", false);
                            $("#createAndContinueWarehouseBtn").prop("disabled", false);
                            $("#cancelWarehouseBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#WarehouseForm").trigger("reset");
                            self.location_id = null;
                            self.code = "";
                            self.name = "";
                            self.description = "";
                            self.type = "";
                            self.distribution_point = "";
                            self.is_default = false;

                        }else{
                            self.$router.push("/warehouse/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createWarehouseBtn").val("Update");
                        $("#createWarehouseBtn").prop("disabled", false);
                        $("#cancelWarehouseBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#WarehouseForm").trigger("reset");


                            $("#createAndContinueWarehouseBtn").val("Save and Continue");
                            $("#createWarehouseBtn").prop("disabled", false);
                            $("#createAndContinueWarehouseBtn").prop("disabled", false);
                            $("#cancelWarehouseBtn").prop("disabled",false);

                        }else{

                            $("#createWarehouseBtn").val("Save");
                            $("#createWarehouseBtn").prop("disabled", false);
                            $("#createAndContinueWarehouseBtn").prop("disabled", false);
                            $("#cancelWarehouseBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'warehouse-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    loadWarehouse() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/warehouse/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    if(data.content.location_id == null){
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locName + " (" + data.content.locCode +")")};
                    }
                    self.name = data.content.name;
                    self.code = data.content.code;
                    self.description = data.content.description;
                    self.type = data.content.type;
                    self.distribution_point = data.content.distribution_point;
                    if (data.content.is_default == 1) {
                        $("#is_default_warehouse").prop("checked",true);
                        self.is_default = true;
                    }else{
                        $("#is_default_warehouse").prop("checked",false);
                        self.is_default = false;
                    }
                  if (data.content.is_fuel_warehouse == 1) {
                    $("#is_fuel_warehouse").prop("checked",true);
                    self.is_fuel_warehouse = true;
                  }else{
                    $("#is_fuel_warehouse").prop("checked",false);
                    self.is_fuel_warehouse = false;
                  }
                    self.def_warehouse_code = data.content.def_warehouse_code;
                    self.def_warehouse_found = data.content.def_warehouse_found;

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'warehouse-get-by-id')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    isDefault(evt) {
        var self = this;
        if(evt.target.checked) {
            self.is_default = true;
            var warnMsg = 'Are you sure that you want to set this Warehouse as Default?';
            if (self.def_warehouse_found == "yes") {
                if (self.def_warehouse_code != "current") {
                    warnMsg = 'Default Warehouse ' + self.def_warehouse_code + ' already exists.';
                    warnMsg += ' Are you sure that you want to set this Warehouse as Default?'
                }
            }
            self.$swal({
                title: warnMsg,
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    self.is_default = true;
                } else {
                    self.is_default = false;
                }
            });
        }else{
            self.is_default = false;
        }
    },
    isFuelWarehouse(evt) {
      var self = this;
      if(evt.target.checked) {
        self.is_fuel_warehouse = true;
        var warnMsg = 'Are you sure that you want to set this Warehouse as a fuel warehouse?';
        self.$swal({
          title: warnMsg,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          showCloseButton: false,
          showLoaderOnConfirm: true
        }).then((result) => {
          if (result.value) {
            self.is_fuel_warehouse = true;
          } else {
            self.is_fuel_warehouse = false;
          }
        });
      }else{
        self.is_fuel_warehouse = false;
      }
    }
  }
};
</script>
<style scoped>
/* for font size in sweet alert */
.swal2-popup .swal2-title {
    font-size: 1.2em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouse/WarehouseCreate.vue